import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: relative;
  background-image: url(https://cdn.midjourney.com/bb154ad4-c676-4cfc-b1b6-96c75bd91e74/0_0.png);
  background-size: cover;
  background-position: center bottom;
`;
